import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Info, LoaderWithContainer } from '@winelidays/wld-tsx-2/elements';
import { useCancellationTexts } from '@winelidays/wld-tsx-2/hooks';
const CancellationInfo = (t0) => {
    const $ = _c(13);
    const { loading, cancellation, filters, completion, calculatedPrice } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const eventDate = completion.date && filters.date && filters.date.startDate || undefined;
    const eventTime = completion.time && filters.time && filters.time.eventTime && filters.time.eventTime.time || undefined;
    const totalPrice = calculatedPrice?.subTotal ?? undefined;
    const bookingFees = calculatedPrice?.fees ?? 0;
    const t1 = cancellation;
    let t2;
    if ($[0] !== bookingFees || $[1] !== currencySymbol || $[2] !== eventDate || $[3] !== eventTime || $[4] !== t1 || $[5] !== totalPrice || $[6] !== translate) {
        t2 = { bookingFees, cancellation: t1, eventDate, eventTime, totalPrice, currencySymbol, translate, locale: LOCALE };
        $[0] = bookingFees;
        $[1] = currencySymbol;
        $[2] = eventDate;
        $[3] = eventTime;
        $[4] = t1;
        $[5] = totalPrice;
        $[6] = translate;
        $[7] = t2;
    }
    else {
        t2 = $[7];
    }
    const { title, description } = useCancellationTexts(t2);
    const text = cancellation.fees?.value ? `${title} ${description}` : title;
    let t3;
    if ($[8] !== loading || $[9] !== text) {
        t3 = loading ?
            <LoaderWithContainer loaderClassName="self-stretch !flex-row !justify-start"/> :
            text;
        $[8] = loading;
        $[9] = text;
        $[10] = t3;
    }
    else {
        t3 = $[10];
    }
    const computedContent = t3;
    let t4;
    if ($[11] !== computedContent) {
        t4 = <Info>{computedContent}</Info>;
        $[11] = computedContent;
        $[12] = t4;
    }
    else {
        t4 = $[12];
    }
    return t4;
};
export default CancellationInfo;
